import React, { Component } from 'react';

import classNames from 'classnames/bind';
import style from './GoogleMaps.scss';
const ctx = classNames.bind(style);

const OPTIONS = {
  styles: [
    {
      featureType: 'all',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#ffffff' }],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#000000' }, { lightness: 13 }],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [{ color: '#000000' }],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#144b53' }, { lightness: 14 }, { weight: 1.4 }],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [{ color: '#08304b' }],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ color: '#0c4152' }, { lightness: 5 }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{ color: '#000000' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#0b434f' }, { lightness: 25 }],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [{ color: '#000000' }],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#0b3d51' }, { lightness: 16 }],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [{ color: '#000000' }],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [{ color: '#146474' }],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [{ color: '#021019' }],
    },
  ],
};

const YOUR_GOOGLE_MAP_API_KEY =
  process.env.NODE_ENV === 'production'
    ? 'AIzaSyBx4AydTE74oC0V0_Kb2sb82uSb-jYoQko'
    : 'AIzaSyCc-EsvzIi-fvx3sZLYUML659aIzodUQhE';

import GoogleMap from 'google-map-react';

class GreatPlace extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor(props) {
    super(props);
  }

  render() {
    const {
      selected,
      onResetSelectPlace,
      photo,
      name,
      description,
    } = this.props;

    return (
      <div>
        <div className={ctx('hint', { 'hint--isSeleced': selected })}>
          <div className={ctx('shadow')} />
          {selected && <div className={ctx('arrow')} />}
          {selected && (
            <div className={ctx('info')}>
              <img className={ctx('photo')} src={photo} width="100%" />
              <div className={ctx('closer')} onClick={onResetSelectPlace}>
                ЗАКРЫТЬ
              </div>
              <div className={ctx('name')}>{name}</div>
              <div className={ctx('description')}>{description}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default class EventsMapPage extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
  }

  _onChildClick = (key, childProps) => {
    this.props.onSelectPlace(key);

    const { mapCenter } = childProps;

    if (mapCenter) {
      this.props.onCenterChange([mapCenter.lat, mapCenter.lng]);
    }
  };

  render() {
    const places = this.props.greatPlaces.map(place => {
      const { id, ...coords } = place;

      return (
        <GreatPlace
          onResetSelectPlace={this.props.onResetSelectPlace}
          key={id}
          {...coords}
          text={id}
          selected={this.props.selectedId === id}
        />
      );
    });

    return (
      <GoogleMap
        options={OPTIONS}
        apiKey={YOUR_GOOGLE_MAP_API_KEY}
        center={this.props.center}
        zoom={9}
        hoverDistance={20}
        onChildClick={this._onChildClick}
      >
        {places}
      </GoogleMap>
    );
  }
}
